import styled from 'styled-components';
import { Box, Inline } from '@99designs/emu';
import { useTrackLink } from '@99designs/tracking';
import { ProductCard } from '../ProductCard';
import { Scroll } from '../layout';
import type { TrackEvent } from '@99designs/tracking';
import type { ProductCardProps } from '../ProductCard';

type WrappedProductCardProps = {
    product: ProductCardProps;
    tracking?: (product: ProductCardProps) => TrackEvent;
};

const StyledInline = styled(Inline)`
    align-items: stretch;
`;

const WrappedProductCard = ({ product, tracking }: WrappedProductCardProps) => {
    const trackingDetails: TrackEvent =
        tracking instanceof Function ? tracking(product) : { event: '' };

    const productCardRef = useTrackLink(trackingDetails);

    return (
        // Padding is required so hover styles are not cut off by scroll
        <Box paddingTop="1.5bu" paddingBottom="3bu" height="100%">
            <ProductCard
                url={product.url}
                title={product.title}
                description={product.description}
                price={product.price}
                saving={product.saving}
                image={product.image}
                deliverables={product.deliverables}
                ref={tracking ? productCardRef : undefined}
            />
        </Box>
    );
};

export interface ProductCardGroupProps {
    products: ProductCardProps[];
    tracking?: (product: ProductCardProps) => TrackEvent;
}

export function ProductCardGroup({ products, tracking }: ProductCardGroupProps) {
    return (
        <Scroll controlsEnabled gridWidth={1300}>
            <StyledInline space={['1.5bu', '2bu', '2bu', '2bu']}>
                {products.map((product) => (
                    <WrappedProductCard product={product} tracking={tracking} key={product.title} />
                ))}
            </StyledInline>
        </Scroll>
    );
}
